import { apiGeneral } from './_General';

export const apiListHomepageImages = {
  getHomepageImages(cb, eCb) {
    apiGeneral.apiFetch('public/list_homepage_images', {
      $orderby: 'sequence'
    }, null, cb, eCb);
  }
};
